import V from 'voUtils/V.js';
import DateEx from 'voUtils/DateEx.js';

import {
	fireFormSubmit
}
from 'voUtils/TagEx.js';
import {
	doPost
}
from 'voUtils/RestEx.js';
import {
	findPreviousSiblingByName
}
from 'voUtils/BrowserEx.js';

export default {
	voVueComponent: 'voffice-form',
	data: function () {
		var fd = VOFFICE.testmode ? {
			forename: 'John',
			surname: 'Doe',
			email: 'test@test.de',
			mobile: '342344 234234',
			message: 'Hallo World!'
		} : {};
		return {
			formData: fd,
			status: 'ready',
			travelperiod: '',
			guests: {
				adults: '',
				children: '',
				babys: '',
				petsCount: ''
			},
			maxPets: undefined,
			maxBabys: undefined,
			error: undefined

		};
	},
	props: {
		subject: String,
		ngaction: String,
		from: String,
		till: String
	},
	computed: {
		periodLabel: function () {
			let label = '';
			if (this.formData.from) {
				label = this.voFormatDate(this.formData.from, 'withDay');
			}
			if (this.formData.till) {
				label += ' - ' + this.voFormatDate(this.formData.till, 'withDay');
			}

			var inputs = document.getElementsByClassName("period-input");
			for (var i = 0; i < inputs.length; i++) {
				if (inputs[i].classList.contains('formerror')) {
					inputs[i].classList.remove('formerror');
				}
			}

			return label;
		},
		customGuestLabel: function () {
			let label;
			var sd = this.guests;
			if (sd.adults) {
				label = sd.adults + ' ' + this.voMsgPl('adult.pl', sd.adults);
				this.formData.adults = sd.adults;
				if (sd.children > 0) {
					label += ', ' + sd.children + ' ' + this.voMsgPl('child.pl', sd.children);
					this.formData.children = sd.children;
				}
				if (sd.babys > 0) {
					label += ', ' + sd.babys + ' ' + this.voMsgPl('baby.pl', sd.babys);
					this.formData.babys = sd.babys;
				}
				if (sd.petsCount > 0) {
					label += ', ' + sd.petsCount + ' ' + this.voMsgPl('pet.pl', sd.petsCount);
					this.formData.petsCount = sd.petsCount;
				}
				var inputs = document.getElementsByClassName("guest-input");
				for (var i = 0; i < inputs.length; i++) {
					if (inputs[i].classList.contains('formerror')) {
						inputs[i].classList.remove('formerror');
					}
				}

			}
			return label;
		},
		setUnit: function () {
			let el = document.querySelector("[data-unit-code]");
			if (el) {
				this.formData.object = el.getAttribute('data-unit-code');
			}
		},

	},

	mounted: function () {
		setTimeout(() => {
			if (this.from && this.till) {
				this.formData.from = this.from;
				this.formData.till = this.till;
			}
		}, 0);
		var labels = {};
		var order = [];

		this.$el.querySelectorAll('[data-formdata-field]').forEach((el) => {
			var field = el.getAttribute('data-formdata-field');
			let label = el.getAttribute('voffice-form-field-label');

			if (!label) {
				let labelEl = findPreviousSiblingByName(el, 'label');
				if (!labelEl) {
					let id = el.getAttribute('id');
					if (id) {
						labelEl = this.$el.querySelector('[for="' + id + '"]');
					}
				}
				if (labelEl) {
					label = labelEl.textContent;
				}

			}

			if (label) {
				labels[field] = label;
			} else {
				V.warn(`could not find label for field ${field}, please use label, 'for' or 'voffice-form-field-label' attribute`);
			}

			order.push(field);


		});

		this.labels = labels;
		this.order = order;

		const petsEl = document.querySelector("[data-pets-restriction]");
		if (petsEl) {
			let maxPets = petsEl.getAttribute('data-pets-restriction');
			switch (maxPets) {
			case '0':
				this.maxPets = 1;
				break;
			case '1':
				this.maxPets = 2;
				break;
			case '2':
				this.maxPets = 3;
				break;
			}
		}
		const babysEl = document.querySelector("[data-babybed]");
		if (babysEl) {
			console.log('Baby-Element gefunden');
			let maxBabys = petsEl.getAttribute('data-babybed');
			this.maxBabys = maxBabys;
		}
	},
	methods: {
		checkDate: function (dateToCheck) {
			var dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;

			if (dateFormatRegex.test(dateToCheck)) {
				return true;
			} else {
				return false;
			}
		},
		checkForm: function (id) {
			var formValid = true;
			var firstErrorField = null;
			var el = document.getElementById(id);
			var inputs = el.querySelectorAll("[required]");

			inputs.forEach(function (input) {
				input.addEventListener('input', () => {
					if (input.type === 'checkbox' && input.checked) {
						var innerElement = document.getElementById(input.id);
						var parentElement = innerElement.parentNode;
						parentElement.classList.remove('formerror');
					} else if (input.classList.contains('formerror')) {
						this.removeFormError(input);
					}
				});
				if (input.type === 'select-one' && input.value === '') {
					input.classList.add('formerror');
					formValid = false;
					if (!firstErrorField) {
						firstErrorField = input;
					}
				} else if (input.type === 'text' && !input.value.trim()) {
					input.classList.add('formerror');
					formValid = false;
					if (!firstErrorField) {
						firstErrorField = input;
					}
				} else if (input.type === 'email' && !input.value.trim()) {
					input.classList.add('formerror');
					formValid = false;
					if (!firstErrorField) {
						firstErrorField = input;
					}
				} else if (input.type === 'date' && (!input.value.trim() || input.value == 'mm/dd/yyyy')) {
					input.classList.add('formerror');
					formValid = false;
					if (!firstErrorField) {
						firstErrorField = input;
					}
				} else if (input.type === 'textarea' && !input.value.trim()) {
					input.classList.add('formerror');
					formValid = false;
					if (!firstErrorField) {
						firstErrorField = input;
					}
				} else if (input.type == 'checkbox') {
					if (!$('#' + input.id).is(":checked")) {
						var innerElement = document.getElementById(input.id);
						var parentElement = innerElement.parentNode;
						parentElement.classList.add('formerror');
						formValid = false;
						if (!firstErrorField) {
							firstErrorField = input;
						}
					} else {
						// Entfernen Sie die Klasse "formerror", wenn das Feld korrekt ausgefüllt ist
						this.removeFormError(input);
					}
				} else {
					input.classList.remove('formerror');
				}
			}, this);

			if (!formValid) {
				if (firstErrorField) {
					firstErrorField.focus();
					var offsetTop = firstErrorField.offsetTop;
					window.scrollTo({
						top: offsetTop - 50,
						behavior: 'smooth'
					});
				}
				return;
			} else {
				this.submit();
			}
		},
		removeFormError: function (input) {
			input.classList.remove('formerror');
		},
		transformDate: function (originalDate) {
			var dateObj = new Date(originalDate);
			var day = dateObj.getDate();
			var month = dateObj.getMonth() + 1;
			var year = dateObj.getFullYear();

			if (day < 10) {
				day = "0" + day;
			}

			if (month < 10) {
				month = "0" + month;
			}

			var convertedDate = day + "." + month + "." + year;
			return convertedDate;
		},
		checkEmail: function (e) {
			var email = e.target.value;

			if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
				$('#email-error').remove();
				$(":submit").prop('disabled', false);
				return true;
			} else {
				$(":submit").prop('disabled', true);
				$("#input_email").after('<div id="email-error" style="color:white; background: red; font-size: 13px; padding:2px 15px; margin-top:5px; border-radius: 5px">' + this.voMsg("email.invalid") + '</div>');
				return false;
			}
		},
		areChildrenWelcome: function () {
			if (this.childrenWelcome == undefined) {
				let el = document.querySelector("[data-children-welcome]");
				if (el) {
					this.childrenWelcome = el.getAttribute('data-children-welcome') == '1';
				} else {
					this.childrenWelcome = false;
				}
			}
			return this.childrenWelcome;
		},
		arePetsWelcome: function () {
			if (this.petsWelcome == undefined) {
				let el = document.querySelector("[data-pets-welcome]");
				if (el) {
					this.petsWelcome = el.getAttribute('data-pets-welcome') == '1';
				} else {
					this.petsWelcome = false;
				}
			}
			return this.petsWelcome;
		},
		areBabysWelcome: function () {
			if (this.babysWelcome == undefined) {
				let el = document.querySelector("[data-babys-welcome]");
				if (el) {
					this.babysWelcome = el.getAttribute('data-babys-welcome') == '1';
				} else {
					this.babysWelcome = false;
				}
			}
			return this.babysWelcome;
		},
		getMaxValues: function () {
			var object = {};
			if (this.maxPets > 0) {
				object.petsCount = this.maxPets;
			}
			if (this.maxBabys > 0) {
				object.babys = this.maxBabys;
			}
			//console.log('getMaxValues::', object);
			return object;
		},
		scrollToResult: function () {
			let el = document.getElementById('inquiry-answer');
			if (el) {
				el.scrollIntoView({
					behavior: 'smooth'
				});
			}
		},
		submit: function () {

			this.status = 'submitting';

			var data = {
				subject: this.subject,
				form: DateEx.formatDates(this.formData, undefined, VOFFICE.mlang),
				search: DateEx.encodeDates(this.$parent.searchData),
				unit: this.$parent.getUnitId && this.$parent.getUnitId(),
				labels: this.labels,
				order: this.order
			};

			const formDataCopy = Object.assign({}, this.formData);

			if (formDataCopy.from && this.checkDate(formDataCopy.from)) {
				var from = this.transformDate(formDataCopy.from);
				formDataCopy.from = from;
			}
			if (formDataCopy.till && this.checkDate(formDataCopy.till)) {
				var till = this.transformDate(formDataCopy.till);
				formDataCopy.till = till;
			}

			fireFormSubmit(data);
			this.error = undefined;

			doPost(this.ngaction || 'saveMessage', {
					subject: this.subject,
					form: DateEx.formatDates(formDataCopy, undefined, VOFFICE.mlang),
					search: DateEx.encodeDates(this.$parent.searchData),
					unit: this.$parent.getUnitId && this.$parent.getUnitId(),
					labels: this.labels,
					order: this.order
				})
				.then((res) => {
					this.status = 'done';
					this.scrollToResult();
				})
				.catch((e) => {
					this.status = 'failed';
					this.error = e;
				});
		}
	}
};